import { ByCountry } from "@arelia-types/index";

export const calcPercentage = (x: number, y: number): number => {
  if (y === 0) {
    return 0;
  }
  return (x / y) * 100;
}

export const large = "#25BB9D";
export const medium = "#06B2DA";
export const small = "rgba(6, 178, 218, 0.35)";
export const zero = "rgba(6, 178, 218, 0.2)";

export const calcBackgroundColor = (average: ByCountry, key: string): string => {
  return average[key] >= 20 ? large : average[key] >= 1 ? medium : average[key] > 0 ? small : zero;
}